

import { Link } from "react-router-dom"
import Layout from "../components/layout/Layout"
export default function Contact() {

	return (
		<>

			<Layout headerStyle={1} footerStyle={1} breadcrumbTitle="title">
				<div>
					<div className="page-title page-title-blog">
						<div className="themeflat-container">
							<div className="row">
								<div className="col-md-12">
									<div className="page-title-heading">
										<h1 className="title">Hisoratra anarana</h1>
									</div>{/* /.page-title-captions */}
									<div className="breadcrumbs">
										<ul>
											<li><Link to="/">Rohy</Link></li>
											<li><i className="icon-Arrow---Right-2" /></li>
											<li><a>Fisoratana anarana</a></li>
										</ul>
									</div>{/* /.breadcrumbs */}
								</div>{/* /.col-md-12 */}
							</div>{/* /.row */}
						</div>{/* /.container */}
					</div>{/* /.page-title */}
					{/* Map Contact us */}
					<div className="map-contact-us">
						<div className="map-contact relative">
							<iframe
								title="Fandriana Madagascar"
								width="100%"
								height="450"
								style={{ border: 0 }}
								loading="lazy"
								src="https://www.google.com/maps?q=Fandriana%20Madagascar&output=embed"
							/>

						</div>
					</div>
					{/* Map Contact us */}
					{/* Contact us */}
					<div className="tf-contact-page main-content">
						<div className="themeflat-container">
							<div className="row contact-page">
								<div className="col-md-5">
									<div className="contact-page-content">
										<div className="content-page-title">
											<span className="wow fadeInUp animated"> FISORATANA ANARANA</span>
											<h2 className="wow fadeInUp animated"></h2>
											<p className="post wow fadeInUp animated">
												Misokatra ny fisoratana anarana manomboka ny 29 Novambra 2025, amin’ireto toerana ireto.
												🏢 Commune Urbaine Fandriana <br/>
												🏢 Salfa Ambozontany <br/>
												🏢 SFM Ambozontany <br/>
												📻 Radio Mangoro <br/>
											</p>
										</div>
										<div className="list-contact-us">
											<div className="inner">
												<span className="wow fadeInUp animated">Phone: </span>
												<h6 className="wow fadeInUp animated">034 41 099 09 / 032 02 006 16</h6>
											</div>
											<div className="inner">
												<span className="wow fadeInUp animated">Email:</span>
												<Link href="#" className="wow fadeInUp animated">
													<h6>hazakazaka@fandriana-milay.org</h6>
												</Link>
											</div>
											<div className="inner">
												<span className="wow fadeInUp animated">Location:</span>
											</div>
										</div>
										<div className="social-contact">
											<ul className="social-media wow fadeInUp animated">
												<li>
													<Link to="/twitter.com"><i className="icon-facebook" /></Link>
												</li>

											</ul>
										</div>
									</div>
								</div>
								<div className="col-md-7">
									<div className="contact-page-form">
										<form id="contactform-page" className="contact-page form-submit" action="/" acceptCharset="utf-8" noValidate="novalidate">
											<div className="text-wrap clearfix">
												<fieldset className="name-wrap">
													<input type="text" id="name" className="tb-my-input" name="name" tabIndex={1} placeholder="Anarana" size={32} aria-required="true" required />
												</fieldset>
												<fieldset className="email-wrap">
													<input type="email" id="email" className="tb-my-input" name="email" tabIndex={2} placeholder="Ny mailaka" size={32} aria-required="true" required />
												</fieldset>
												<fieldset className="phone-wrap">
													<input type="tel" id="phone" className="tb-my-input" name="phone" tabIndex={1} placeholder="Telephone" size={32} aria-required="true" required />
												</fieldset>
												<fieldset className="age-wrap">
													<input type="text" id="age" className="tb-my-input" name="site" tabIndex={1} placeholder="Taona" size={32} aria-required="true" required />
												</fieldset>
												<fieldset className="phone-wrap">
													<select name="" id="">
														<option value="">Sokajy</option>
														<option value="">5km</option>
														<option value="">15km</option>
													</select>
												</fieldset>
											</div>
											<fieldset className="message-wrap">
												<textarea id="comment-message" name="message" rows={3} tabIndex={4} placeholder="Message" aria-required="true" defaultValue={""} />
											</fieldset>
											<button name="submit" type="submit" id="comment-reply" className="flat-button btn-submit-comment"><span>Hisoratra anarana</span></button>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</Layout>
		</>
	)
}